import React, { Component, Fragment } from "react";
import { Row, Col } from "reactstrap";
import "bootstrap-daterangepicker/daterangepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import axios from "../../../../axios-instance";
import { getAdminBusinessId } from "../../../../utils/authHelper";
import { mapDatePickerFormatToMoment } from "../../../../utils/eventConfigHelpers";
import Loader from "../../../../components/Loader/Loader";
import isEmpty from "../../../../validation/is-empty";
import { dateRangeEvents, requestInviteeToRescheduleAction } from "../../../../actions/admin/scheduled-event-actions";
import { Pagination } from "antd";
import { connect } from "react-redux";
import UpcomingViewDetailsModal from "./upcoming-view-details-modal";
import PastViewDetails from "./past-view-details";
import ScheduledEventCard from "./ScheduledEventCard";
import ScheduledDayGroup from "./ScheduledDayGroup";
import { notification } from "../../../../utils/utility";

class DateRange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLoading: false,
      events: [],
      totalEvents: 0,
      bookingId: null,
      pagination: {
        current: 1,
        pageSize: 10,
      },
      filter: {},
      startDate: "",
      endDate: "",
      showUpcomingEventDetail: false,
      showPastEventDetail: false,
      datePickerFormat: "MM/DD/YYYY",
    };
  }

  componentDidMount() {
    const startDate = moment().format("YYYY-MM-DD");
    const endDate = moment().add(14, "d").format("YYYY-MM-DD");
    const { pagination } = this.state;

    this.setState({
      startDate,
      endDate,
      pageLoading: true,
    });

    this.fetchListEvents({
      pagination,
      filters: {
        start_date: startDate,
        end_date: endDate,
      },
    });

    const businessId = getAdminBusinessId();
    if (!businessId) {
      return;
    }

    axios
      .get(`/admin/settings/event/${businessId}`)
      .then((res) => {
        const resData = res?.data || {};
        const config = resData?.data?.data || resData?.data || {};
        this.setState({
          datePickerFormat: mapDatePickerFormatToMoment(
            config.date_picker_format || "mm/dd/yyyy"
          ),
        });
      })
      .catch(() => {});
  }

  hideViewDetailModal = () => {
    this.setState({
      showUpcomingEventDetail: false,
      showPastEventDetail: false,
    });
  };

  prepareDataParam = (params) => {
    let sortField = "id";
    let sortOrder = "asc";

    if (!isEmpty(params.sortField) && !isEmpty(params.sortOrder)) {
      sortField = params.sortField;
      sortOrder = params.sortOrder === "ascend" ? "asc" : "desc";
    }

    return {
      pageSize: params.pagination.pageSize,
      pageNumber: params.pagination.current,
      sortField,
      sortOrder,
      filter: {
        ...params.filters,
      },
    };
  };

  getDateFilters = (filters = {}) => ({
    start_date: filters.start_date || this.state.startDate,
    end_date: filters.end_date || this.state.endDate,
  });

  onPageChange = (page, pageSize) => {
    this.setState({
      pageLoading: true,
    });
    this.fetchListEvents({
      pagination: {
        current: page,
        pageSize: pageSize,
      },
      filters: this.getDateFilters(),
    });
  };

  fetchListEvents = (params = {}) => {
    const { dateRangeEvents } = this.props || {};
    const filters = this.getDateFilters(params.filters || {});
    dateRangeEvents({
      data: this.prepareDataParam({
        ...params,
        filters,
      }),
      onSuccess: (response) => {
        const { data, total } = response;
        this.setState({
          events: data,
          totalEvents: total,
          pageLoading: false,
          pagination: { ...params.pagination },
        });
      },
      onError: (error) => {
        console.error(error);
        this.setState({ pageLoading: false });
      },
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.fetchListEvents({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      filters,
    });
  };

  onFilterDataTable = (startDate, endDate) => {
    this.handleTableChange(
      {
        current: 1,
        pageSize: this.state.pagination.pageSize,
      },
      {
        start_date: startDate,
        end_date: endDate,
      },
      {}
    );
  };

  onUpcomingEventDetail = (bookingData) => {
    this.setState({
      bookingId: bookingData.id,
      showUpcomingEventDetail: true,
    });
  };

  onPastEventDetail = (bookingData) => {
    this.setState({
      bookingId: bookingData.id,
      showPastEventDetail: true,
    });
  };

  onViewDetail = (event) => {
    if (event.is_past_event === "E") {
      this.onPastEventDetail(event);
      return;
    }
    this.onUpcomingEventDetail(event);
  };

  updatePastEventStatus = (id, status) => {
    const processedEvents = { ...this.state.events };
    Object.keys(processedEvents).forEach((key) => {
      (processedEvents[`${key}`] || []).forEach((event) => {
        if (event.id === id) {
          event.status = status;
        }
      });
    });
    this.setState({
      events: processedEvents,
    });
    this.hideViewDetailModal();
  };

  getRemainingTime = (bookingDateTime) => {
    if (!bookingDateTime) {
      return null;
    }
    const diffDuration = moment.duration(
      moment(bookingDateTime).diff(moment())
    );
    if (diffDuration.asSeconds() <= 0) {
      return null;
    }
    const days = Math.floor(diffDuration.asDays());
    const hours = diffDuration.hours();
    const minutes = diffDuration.minutes();
    const parts = [];
    if (days > 0) {
      parts.push(`${days}d`);
    }
    if (hours > 0 || days > 0) {
      parts.push(`${hours}h`);
    }
    parts.push(`${minutes}m`);
    return `Starts in ${parts.join(" ")}`;
  };

  onRequestInviteeToReschedule = (bookingId) => {
    const { requestInviteeToRescheduleAction } = this.props || {};
    const { startDate, endDate } = this.state;

    this.setState({
      pageLoading: true,
    });
    requestInviteeToRescheduleAction({
      data: { id: bookingId },
      onSuccess: () => {
        notification.success(
          "Request invitee to reschedule sent successfully."
        );
        this.hideViewDetailModal();
        this.onFilterDataTable(startDate, endDate);
      },
      onError: (error) => {
        console.error(error);
        this.setState({ pageLoading: false });
      },
    });
  };

  render() {
    const {
      pageLoading,
      events,
      pagination,
      startDate,
      endDate,
      bookingId,
      showUpcomingEventDetail,
      showPastEventDetail,
      datePickerFormat,
    } = this.state || {};

    return (
      <>
        {showUpcomingEventDetail && (
          <UpcomingViewDetailsModal
            bookingId={bookingId}
            showViewDetailModal={showUpcomingEventDetail}
            handleClose={this.hideViewDetailModal}
            loadUpcomingEvents={() =>
              this.onFilterDataTable(startDate, endDate)
            }
            onRequestInviteeToReschedule={this.onRequestInviteeToReschedule}
          />
        )}

        {showPastEventDetail && (
          <PastViewDetails
            bookingId={bookingId}
            showViewDetailModal={showPastEventDetail}
            handleClose={this.hideViewDetailModal}
            updatePastEventStatus={this.updatePastEventStatus}
          />
        )}

        <Loader isShowLoader={pageLoading} />
        <div className="rd_pasevencontth">
          <div className="se-range-bar">
            <label htmlFor="scheduled-date-range">Date range</label>
            <DateRangePicker
              initialSettings={{
                startDate: moment(),
                endDate: moment().add(14, "d"),
                locale: {
                  format: datePickerFormat,
                },
              }}
              onCallback={(start, end) => {
                const nextStart = moment(start).format("YYYY-MM-DD");
                const nextEnd = moment(end).format("YYYY-MM-DD");
                this.setState({
                  startDate: nextStart,
                  endDate: nextEnd,
                  pageLoading: true,
                });
                this.onFilterDataTable(nextStart, nextEnd);
              }}
            >
              <input
                id="scheduled-date-range"
                type="text"
                readOnly
                className="se-range-bar__input"
              />
            </DateRangePicker>
          </div>

          {Object.keys(events).length > 0 ? (
            <Fragment>
              {Object.keys(events).map((key) => (
                <ScheduledDayGroup dateKey={key} key={key}>
                  {(events[`${key}`] || []).map((event, innerIndex) => (
                    <ScheduledEventCard
                      key={event.id || innerIndex}
                      event={event}
                      onViewDetail={this.onViewDetail}
                      subtitle={
                        event.is_past_event === "E" ||
                        event.status === "CC" ||
                        event.status === "CS"
                          ? null
                          : this.getRemainingTime(event.booking_date_time)
                      }
                    />
                  ))}
                </ScheduledDayGroup>
              ))}
            </Fragment>
          ) : !pageLoading ? (
            <div className="se-empty">
              <strong>No events in this range</strong>
              <span>Try another date range, or check Upcoming and Past.</span>
            </div>
          ) : null}

          {Object.keys(events).length > 0 && (
            <Row className="pb-4 pr-md-3">
              <Col className="text-center" lg="12" md="12">
                <Pagination
                  className="list-view-pagination"
                  defaultCurrent={pagination.current}
                  current={pagination.current}
                  total={this.state.totalEvents}
                  pageSize={pagination.pageSize}
                  onChange={this.onPageChange}
                  showSizeChanger={false}
                />
              </Col>
            </Row>
          )}
        </div>
      </>
    );
  }
}

export default connect(null, {
  dateRangeEvents,
  requestInviteeToRescheduleAction,
})(DateRange);
